import { render, staticRenderFns } from "./Sizes.vue?vue&type=template&id=6757fd80&scoped=true&"
import script from "./Sizes.vue?vue&type=script&lang=js&"
export * from "./Sizes.vue?vue&type=script&lang=js&"
import style0 from "./Sizes.vue?vue&type=style&index=0&id=6757fd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6757fd80",
  null
  
)

export default component.exports